"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const SlidingDoorTooltip_1 = tslib_1.__importDefault(require("../tooltip/SlidingDoorTooltip"));
/**
 * @deprecated use {@link ToggleTip} instead
 */
class Tooltip {
    static setTooltipHandlerImpl(tooltipHandler) {
        this.handler = tooltipHandler;
    }
    static fromString(target, tip) {
        this.handler.add(target, tip, undefined, undefined);
    }
    static fromCallback(target, tip) {
        this.handler.add(target, undefined, tip, undefined);
    }
    static fromPromise(target, tip) {
        this.handler.add(target, undefined, undefined, tip);
    }
    static remove(target) {
        this.handler.remove(target);
    }
}
Tooltip.handler = new SlidingDoorTooltip_1.default();
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map